import React, { useEffect, useState } from "react";
import Footer from "../components/footer";
import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`  
  header#myHeader.navbar.white {
    background: #FAF6F1;
  }
`;
const domainpath = process.env.REACT_APP_API_DOMAIN_ENDPOINT;
const Activity = function () {
  const [activity, setActivity] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filteredActivity, setFilteredActivity] = useState([]);
  const [activeFilter, setActiveFilter] = useState("all");
  const [nftTitles, setNftTitles] = useState({}); // Store NFT titles by ID

  useEffect(() => {
    const fetchActivity = async () => {
      setLoading(true);
      try {
        const walletAddress = localStorage.getItem("walletAddress");
        if (!walletAddress) return;

        // Fetch activity data
        const res = await fetch(`${domainpath}/api/history/${walletAddress}`);
        const data = await res.json();

        // Create NFT titles mapping from activity data
        const titles = {};
        data.forEach((item) => {
          if (item.action === "Created NFT") {
            titles[item.nft_id] = item.details;
          }
        });
        setNftTitles(titles);

        setActivity(data);
        setFilteredActivity(data);
      } catch (err) {
        console.error("Error fetching activity:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchActivity();
  }, []);

  const handleFilterChange = (filterType) => {
    setActiveFilter(filterType);
    switch (filterType) {
      case "follow":
        setFilteredActivity(
          activity.filter((item) => item.action === "follow")
        );
        break;
      case "sale":
        setFilteredActivity(activity.filter((item) => item.action === "sale"));
        break;
      case "like":
        setFilteredActivity(
          activity.filter(
            (item) => item.action === "like" || item.action === "unlike"
          )
        );
        break;
      case "unlike":
        setFilteredActivity(activity.filter((item) => item.action === "like"));
        break;
      case "offer":
        setFilteredActivity(activity.filter((item) => item.action === "offer"));
        break;
      case "created":
        setFilteredActivity(activity.filter((item) => item.action === "mint"));
        break;
      default:
        setFilteredActivity(activity);
    }
  };

  const getActionClassName = (action) => {
    switch (action) {
      case "follow":
        return "act_follow";
      case "sale":
        return "act_sale";
      case "like":
      case "unlike":
        return "act_like";
      case "offer":
        return "act_offer";
      case "mint":
        return "act_created";
      default:
        return "";
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return (
      date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }) +
      ", " +
      date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
      })
    );
  };
  const getMediaElement = (item) => {
    const url = item.nftImageUrl;
    const mime = item.artdata?.mime_type;

    if (!url || !mime) {
      // fallback to avatar
      return (
        <img
          className="lazy"
          src={item.userData?.avatar || "./img/author/author-1.jpg"}
          alt={item.userData?.name || "User"}
        />
      );
    }

    if (mime.startsWith("image/")) {
      return <img className="lazy" src={url} alt="nft media" />;
    }

    if (mime.startsWith("video/")) {
      return (
        <video
          className="lazy"
          src={url}
          controls
          width="100%"
          style={{ borderRadius: "8px" }}
        />
      );
    }

    if (mime.startsWith("audio/")) {
      return (
        <div className="audio-wrapper">
          <img
            className="lazy"
            src="/img/music-placeholder.jpg"
            alt="Audio placeholder"
          />
          <audio controls style={{ width: "100%" }}>
            <source src={url} type={mime} />
            Your browser does not support the audio element.
          </audio>
        </div>
      );
    }

    // Default fallback
    return (
      <img
        className="lazy"
        src={item.userData?.avatar || "./img/author/author-1.jpg"}
        alt={item.userData?.name || "User"}
      />
    );
  };

  const getImageUrl = (item) => {
    // If we have NFT image URL in the item, use that
    if (item.nftImageUrl) return item.nftImageUrl;
    // Otherwise use user avatar
    return item.userData?.avatar || "./img/author/author-1.jpg";
  };

  const getDisplayTitle = (nftId) => {
    return nftTitles[nftId] || `NFT #${nftId}`;
  };

  const renderActivityItem = (item) => {
    switch (item.action) {
      case "Followed":
        return (
          <>
            <h4>{item.userData?.name || "Unknown User"}</h4>
            started following{" "}
            <span className="color">
              {item.details.replace("Followed user ", "")}
            </span>
          </>
        );
      case "Accept Offer":
        return (
          <>
            <h4>{getDisplayTitle(item.nft_id)}</h4>
            {item.details.replace(
              `on NFT #${item.nft_id}`,
              `on ${getDisplayTitle(item.nft_id)}`
            )}
          </>
        );
      case "Liked":
        return (
          <>
            <h4>{getDisplayTitle(item.nft_id)}</h4>
            {item.details.replace(
              `art with ID ${item.nft_id}`,
              getDisplayTitle(item.nft_id)
            )}
          </>
        );
      case "Unliked":
        return (
          <>
            <h4>{getDisplayTitle(item.nft_id)}</h4>
            {item.details.replace(
              `art with ID ${item.nft_id}`,
              getDisplayTitle(item.nft_id)
            )}
          </>
        );
      case "Make Offer":
        return (
          <>
            <h4>{getDisplayTitle(item.nft_id)}</h4>
            {item.details.replace(
              `on NFT #${item.nft_id}`,
              `on ${getDisplayTitle(item.nft_id)}`
            )}
          </>
        );
      case "Created NFT":
        return (
          <>
            <h4>{item.details}</h4>
            Created by{" "}
            <span className="color">
              {item.userData?.name || "Unknown User"}
            </span>
          </>
        );
      default:
        return <h4>{item.details}</h4>;
    }
  };

  return (
    <div>
      <GlobalStyles />

      <section className="jumbotron breadcumb no-bg">
        <div className="mainbreadcumb">
          <div className="container">
            <div className="row m-10-hor">
              <div className="col-12">
                <h1 className="text-center">Activity</h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="container">
        <div className="row">
          <div className="col-md-8">
            {loading ? (
              <div className="text-center">Loading activity...</div>
            ) : filteredActivity.length === 0 ? (
              <div className="text-center">No activities found</div>
            ) : (
              <ul className="activity-list">
                {filteredActivity.map((item, index) => (
                  <li key={index} className={getActionClassName(item.action)}>
                    {getMediaElement(item)}
                    <div className="act_list_text">
                      {renderActivityItem(item)}
                      <span className="act_list_date">
                        {formatDate(item.timestamp)}
                      </span>
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </div>

          <div className="col-md-4">
            <span className="filter__l">Filter</span>
            <span
              className="filter__r"
              onClick={() => handleFilterChange("all")}
            >
              Reset
            </span>
            <div className="spacer-half"></div>
            <div className="clearfix"></div>
            <ul className="activity-filter">
              <li
                id="all"
                className={`filter_by_all ${
                  activeFilter === "all" ? "active" : ""
                }`}
                onClick={() => handleFilterChange("all")}
              >
                <i className="fa fa-list"></i>All
              </li>
              <li
                id="sale"
                className={`filter_by_sales ${
                  activeFilter === "sale" ? "active" : ""
                }`}
                onClick={() => handleFilterChange("sale")}
              >
                <i className="fa fa-shopping-basket"></i>Sales
              </li>
              <li
                id="like"
                className={`filter_by_likes ${
                  activeFilter === "like" ? "active" : ""
                }`}
                onClick={() => handleFilterChange("like")}
              >
                <i className="fa fa-heart"></i>Likes
              </li>
              <li
                id="offer"
                className={`filter_by_offers ${
                  activeFilter === "offer" ? "active" : ""
                }`}
                onClick={() => handleFilterChange("offer")}
              >
                <i className="fa fa-gavel"></i>Offers
              </li>
              <li
                id="follow"
                className={`filter_by_followings ${
                  activeFilter === "follow" ? "active" : ""
                }`}
                onClick={() => handleFilterChange("follow")}
              >
                <i className="fa fa-check"></i>Followings
              </li>
              <li
                id="created"
                className={`filter_by_created ${
                  activeFilter === "created" ? "active" : ""
                }`}
                onClick={() => handleFilterChange("created")}
              >
                <i className="fa fa-plus"></i>Creations
              </li>
            </ul>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Activity;
